import React, { useState } from "react";
import "./scss/floating-input.scss";

export default function FloatingInput({
  label,
  className = "",
  value,
  onChange,
  ...props
}) {
  const [focused, setFocused] = useState(false);

  const isActive = focused || (value && value.toString().length > 0);

  return (
    <div className={`floating-input ${isActive ? "active" : ""} ${className}`}>
      <input
        {...props}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
      <label>{label}</label>
    </div>
  );
}
